import React from 'react';
import { UserProfile } from '@clerk/clerk-react';

// Client-side user profile page using Clerk's UserProfile component.
// This mirrors the Next.js example but uses React Router. We mount
// the component at /user-profile and allow nested paths with the
// React Router catch-all (/*).

const UserProfilePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* The UserProfile component accepts props like routing, path,
            appearance, additionalOAuthScopes, customPages and fallback.
            We use routing="path" so Clerk uses path-based routing. */}
        <UserProfile routing="path" path="/user-profile" />
      </div>
    </div>
  );
};

export default UserProfilePage;
